import { useEffect } from 'react';

// UI
import Button from '@components/button';

// assets
import AppleIcon from '@assets/icons/cib_apple.svg?react';

// styles
import css from './styles.module.css';

interface IProps {
  clientId: string;
  redirectURI: string;
  scope?: string;
  className?: string;
}

const AppleSignInButton = (props: IProps) => {
  const { clientId, redirectURI, scope = 'email name', className = '' } = props;

  useEffect(() => {
    // Load the Apple Sign-In SDK script
    const loadAppleScript = () => {
      const script = document.createElement('script');
      script.src =
        'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
      script.async = true;
      script.id = 'apple-signin-script';
      document.body.appendChild(script);
    };

    // Check if script is already loaded
    if (!document.getElementById('apple-signin-script')) {
      loadAppleScript();
    }
  }, []);

  const handleClick = () => {
    // Initialize Apple Sign-In
    // @ts-expect-error available using script
    window.AppleID.auth.init({
      clientId,
      scope,
      redirectURI,
    });

    // Trigger sign in
    // @ts-expect-error available using script
    window.AppleID.auth.signIn();
  };

  return (
    <Button
      size="large"
      color="grey"
      onClick={handleClick}
      className={className}
    >
      <>
        <AppleIcon className={css.oauthIcon} width={24} height={24} /> Login
        with Apple
      </>
    </Button>
  );
};

export default AppleSignInButton;
